<template>
  <v-container class="home">
    <v-row class="my-3">
      <v-col cols="12" md="8">
        <v-card outlined class="crane-border-cyan" height="100%">
          <v-card-title class="mb-5"
            >Welcome to Operating Systems!</v-card-title
          >
          <v-card-subtitle class="subtitle-2">
            In this class, you'll have the opportunity to learn both the
            overarching principles of operating systems as well as the
            intricacies of how they work.
          </v-card-subtitle>
          <v-card-text>
            <p>
              We'll cover topics including multithreaded programming; managing
              threads, interrupts, and storage; processor scheduling; operating
              system structure; virtualization; security; and the design of both
              local and distributed file systems. You'll develop your skill as a
              C programmer while simultaneously learning what goes on inside
              your computer from the moment you power it on.
            </p>
            <p>
              As part of the class, if you are enrolled in CS167, you may choose
              to take the (optional) half-credit lab, CS169. If you do so, you
              will attend the same lectures and complete the written assignments
              as usual. However, you will only complete the first two
              programming assignments from CS167, before embarking on an
              in-depth project wherein you build much of the functionality of a
              small operating system called Weenix. It is a significant time
              investment, and you'll still get a lot from the class if you don't
              take the lab. Some thoughts on taking CS169 from previous students
              can be found
              <a href="content/169.pdf" target="_blank">here</a>. CS267 covers
              the material of both CS167 and 169; it is for graduate students
              only.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card height="100%" outlined class="crane-border-cyan">
          <v-row class="pa-2">
            <v-card-title>Announcements</v-card-title>
            <v-card-text class="announcements-text">
              <ul>
                <li>
                  Don't forget to fill out the
                  <a
                    href="https://forms.gle/gEV31rLg7d1KzKM97"
										target="_blank"
                  >
                    Onboarding and Collaboration Policy Form</a
                  >!
                </li>
                <li>
                  You can submit anonymous feedback for the course at any time
                  using the
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdE97Jh3R9tQ31BBYOjfALTJAMoeevIV7ehQgewkw2CLHax7g/viewform" target="_blank"
										>
                    Anonymous Feedback Form</a
                  >!
                </li>
              </ul>
            </v-card-text>
            <v-list> </v-list>
          </v-row>
          <v-row justify="center" align="center">
            <img
              :src="`${currentCrane}`"
              alt="The tower crane"
              width="75%"
              class="pb-5"
            />
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-divider />
    <v-row class="my-2">
      <v-col>
        <v-sheet outlined class="crane-border-cyan">
          <v-row>
            <v-col cols="6" md="3">
              <v-card-subtitle class="subtitle-2">Contact</v-card-subtitle>
              <v-card-text>
                <p>
                  For general course-related questions, you can contact the
                  entire staff at:
                  <a href="mailto:cs1670tas@lists.brown.edu"
                    >cs1670tas@lists.brown.edu</a
                  >
                </p>

                <p>
                  For questions about course policies, or more confidential
                  questions:
                  <a href="mailto:cs1670headtas@lists.brown.edu"
                    >cs1670headtas@lists.brown.edu</a
                  >
                </p>
              </v-card-text>
            </v-col>
            <v-col cols="6" md="3">
              <v-card-subtitle class="subtitle-2"
                >Meeting Times</v-card-subtitle
              >
              <v-card-text>
                <p>
                  Lectures: <br />Mondays, Wednesdays, Fridays, 2-2:50pm in
                  Foxboro Auditorium, Kassar House
                </p>
                <p>
                  Help sessions: <br />Occasional Tuesday and Thursday evenings,
                  7–8pm (over Zoom)
                </p>
              </v-card-text>
            </v-col>
            <v-col cols="6" md="3">
              <v-card-subtitle class="subtitle-2"
                >Prerequisites</v-card-subtitle
              >
              <v-card-text>
                CSCI 0300, 0330, 1310, or 1330, or permission of the instructor.
              </v-card-text>
            </v-col>
            <v-col cols="6" md="3">
              <v-card-subtitle class="subtitle-2">Textbook</v-card-subtitle>
              <v-card-text>
                <span class="text-italic">Operating Systems in Depth</span>, by
                Doeppner, Wiley 2011.<br />
                ISBN: 978-0-471-68723-8
              </v-card-text>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      now: new Date(),
    };
  },
  created() {
    // Refresh current time (now) every 5 seconds, so the crane image will
    // update automatically when a new day rolls around and someone happens to
    // have the OS website still open on their computer.
    // Adapted from https://stackoverflow.com/questions/52836501/make-computed-vue-properties-dependent-on-current-time
    var self = this;
    setInterval(function () {
      self.now = new Date();
    }, 5000);
  },
  computed: {
    // Compute which crane image to display depending on the day of the month.
    currentCrane() {
      let colors = [
        "blue",
        "green",
        "orange",
        "pink",
        "purple",
        "red",
        "white",
      ];
      let i = this.now.getDate() % colors.length;
      return `images/crane-drawings/${colors[i]}.png`;
    },
  },
};
</script>
<style scoped>
@import "../styles/crane.css";

.profile {
  width: 250px;
  margin: auto;
}

.profile img {
  width: 200px;
  height: 200px;
  object-fit: cover;
}

.announcements-text ul li {
  margin-top: 2%;
  margin-bottom: 2%;
}

.v-sheet .v-card__text,
.v-card .v-card__text {
  color: white !important;
  font-size: 15px;
}
</style>
